import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { StockAlertListSchema, StockAlertParams } from "../types"

type StockAlertList = {
  items: StockAlertListSchema[]
  pagination_data: {
    total: number
    page: number
    size: number
    pages: number
  }
}

export const useListStockAlert = (props: StockAlertParams) => {
  const defaultValue = {
    items: [],
    pagination_data: { page: 0, pages: 0, size: 0, total: 0 }
  }

  const api = useApi()
  const [data, setData] = useState<StockAlertList>(defaultValue)
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | boolean | undefined } = {};
  if (props?.page) params.page = props?.page;
  if (props?.keyword) params.keyword = props?.keyword;
  if (props?.limit) params.limit = props?.limit;
  if (props?.buy) params.buy = props?.buy;
  if (props?.sell) params.sell = props?.sell;
  if (props?.inv) params.inv = props?.inv;
  if (props?.build) params.build = props?.build;
  if (props?.sort) params.sort = props?.sort;
  if (props?.zero_soh) params.zero_soh = props?.zero_soh;
  if (props?.zero_min) params.zero_min = props?.zero_min;
  if (props?.zero_max) params.zero_max = props?.zero_max;
  if (props?.location_id) params.location_id = props?.location_id;
  if (props?.category_id) params.category_id = props?.category_id;

  const fetchingData = () => api.get("/product/list-product-minmax-loc", { params })
  const fetchData = () => {
    if (!props?.location_id) {
      setData(defaultValue)
      setLoading(false)
      return
    }

    setLoading(true)

    fetchingData()
    .then((res: SuccessFetch<{ payload: StockAlertList }>) => setData(res.data.payload))
    .catch(() => setData(defaultValue))
    .finally(() => setLoading(false))
  }
  const refetch = () => fetchData()

  useEffect(() => {
    refetch()

    return () => {
      setData(defaultValue)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    fetchData()

    return () => {
      setData(defaultValue)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [props?.page, props?.limit, props?.sort, props?.buy, props?.sell, props?.inv, props?.build, props?.keyword, props?.zero_soh, props?.location_id, props?.category_id, props?.zero_min, props?.zero_max])

  return { data, isLoading, refetch }
}